import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Modal, Button, message, Form, InputNumber } from 'antd';
import { DataService } from '../../../config/dataService/dataService';
import { UilFileAlt } from '@iconscout/react-unicons';
import PdfViewer from '../../pdfViewer/pdfViewer';
import { useNavigate } from 'react-router-dom';

const TopupModal = forwardRef((props, ref) => {
  const minAmount = 100;
  const { createdCallbackNewTopup } = props;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const [amount, setAmount] = useState('');
  const [number, setNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [openAttachment, setOpenAttachment] = useState(null);

  useImperativeHandle(ref, () => ({
    open(amount = '') {
      setOpen(true);
      setAmount(amount);
      setNumber('');
      setOpenAttachment(null);
      form.resetFields();

      if (amount) {
        form.setFieldValue('amount', Math.max(minAmount, amount));
      }
    },
  }));

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await DataService.post('/balances/topups', {
        amount: values.amount,
      });

      setAmount(response.data.topup.amount);
      setNumber(response.data.topup.number);

      createdCallbackNewTopup();
    } catch (err) {
      message.error('Wystąpił błąd tworzenia doładowania.');
    }
    setLoading(false);
  };

  const openPdf = async () => {
    try {
      const response = await DataService.get(`/balances/topups/${number}/pdf`, {}, {}, { responseType: 'blob' });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      setOpenAttachment(url);
      setOpen(false);
    } catch (err) {
      message.error('Wystąpił błąd przy otwieraniu pdf.');
    }
  };

  return (
    <>
      {openAttachment && (
        <PdfViewer
          file={openAttachment}
          name={`APPS-PL-RAPORT-ZASILENIA-${number}`}
          onClose={() => setOpenAttachment(null)}
        />
      )}
      <Modal
        title={number ? 'Nowe zasilenie' : 'Utwórz zasilenie'}
        open={open}
        onCancel={() => setOpen(false)}
        footer={
          number
            ? [
                <Button key="close" onClick={() => setOpen(false)} disabled={loading}>
                  Zamknij
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  onClick={() => {
                    setOpen(false);
                    navigate(`/payment/topups/${number}`);
                  }}
                  loading={loading}
                >
                  Opłać
                </Button>,
              ]
            : [
                <Button key="cancel" onClick={() => setOpen(false)} disabled={loading}>
                  Anuluj
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  onClick={() => {
                    form.submit();
                  }}
                  loading={loading}
                >
                  Utwórz
                </Button>,
              ]
        }
      >
        {!number ? (
          <>
            <Form name="contactForm" onFinish={handleSubmit} layout="vertical" form={form}>
              <Form.Item
                label="Kwota"
                name="amount"
                def
                className="[&>div>div>label]:text-sm [&>div>div>label]:text-dark dark:[&>div>div>label]:text-white60 [&>div>div>label]:font-medium"
                rules={[
                  {
                    required: true,
                    message: 'Proszę podać kwotę doładowania',
                  },
                  {
                    type: 'number',
                    min: 100,
                    message: 'Minimalna kwota to 100,00 PLN',
                  },
                ]}
              >
                <InputNumber
                  placeholder="Wprowadź kwotę (min. 100 PLN)"
                  min={minAmount}
                  step={0.01}
                  style={{ width: '100%' }}
                  formatter={(value) =>
                    value
                      ? `${Number(value)
                          .toFixed(2)
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}`
                      : ''
                  }
                  parser={(value) => (value ? value.replace(/\s/g, '') : '')}
                />
              </Form.Item>
            </Form>
          </>
        ) : (
          <>
            <div className="flex flex-col mb-2">
              <p className="text-base font-semibold text-gray-700 mb-0">Numer</p>
              <p className="font-mono text-sm truncate mb-0">{number}</p>
            </div>
            <div className="flex flex-col mb-4 mb-2">
              <p className="text-base font-semibold text-gray-700 mb-0">Kwota</p>
              <p className="font-mono text-sm truncate mb-0">
                {Number(amount)
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}{' '}
                PLN
              </p>
            </div>
            <div className="flex flex-col mb-4 mb-2">
              <p className="text-base font-semibold text-gray-700 mb-2">Raport</p>
              <Button
                onClick={() => {
                  openPdf();
                }}
                style={{
                  border: 'none',
                  width: '50px',
                }}
                className="text-[40px] inline-flex items-center border-deep h-[50px] px-[5px] group [&>span>svg]:text-current transition duration-300"
                outlined
                type="light"
              >
                <UilFileAlt size={40} />
              </Button>
            </div>
          </>
        )}
      </Modal>
    </>
  );
});

export default TopupModal;
